import { z } from 'zod';
// Mandatory email transform — trim, lowercase, NFC normalization
// Order: trim/lowercase/NFC FIRST, then email validation, so inputs with leading/trailing whitespace pass.
export const EmailSchema = z
    .string()
    .transform((email) => email.trim().toLowerCase().normalize('NFC'))
    .pipe(z.string().email('Invalid email format'));
//# sourceMappingURL=email.js.map